// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VUPn","badges":"styles_badges__3QNgY"};